module.exports = __webpack_public_path__ + "img/avatar5.bff6b615.png";